<template>
  <div class="h-full pl-5 pb-8">
    <loading-table :columnNames="columnNames"
                   :data="tableData"
                   :selectedRowIndex="selectedRowIndex"
                   :loading="loading"
                   @click="handleExampleSelect"
    >
      <template #td="{ row, tdClass }">
        <td v-for="(cell,i) in row"
            :key="i"
            :class="[tdClass, {'w-1/2 xl:w-1/4': i === 0}]"
        >
          <div class="flex">
            <img v-if="i === 0"
                 :src="reasonIcons[row[0]]"
                 :alt="row[0]"
                 class="mr-3 relative reason-icon"
            >
            <div class="clamp">{{ cell }}</div>
          </div>
        </td>
      </template>
    </loading-table>
  </div>
</template>

<script>
import LoadingTable from '@/components/common/LoadingTable'
import testReportModule from '@/store/modules/test-report.module'

export default {
  name: 'AnswersReportExamples',

  components: { LoadingTable },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    reasonIcons: {
      type: Object,
      default: () => {}
    },
    reasonLabels: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      columnNames: [
        { text: 'reasons of failure', className: 'uppercase' },
        { text: 'example', className: 'uppercase' }
      ],
      selectedRowIndex: 0
    }
  },

  computed: {
    selectedIntent: testReportModule.getSelectedIntent,
    selectedExample: testReportModule.getSelectedExample,

    examples() {
      return this.selectedIntent.examples?.failed_examples || []
    },

    tableData() {
      return this.examples?.map(({ reason, example }) => {
        return [this.reasonLabels[reason], example]
      })
    }
  },

  watch: {
    examples: {
      deep: true,
      immediate: true,
      handler() {
        this.handleExampleSelect(0)
      }
    }
  },

  methods: {
    handleExampleSelect(selectedRowIndex) {
      this.selectedRowIndex = selectedRowIndex
      const selectedExample = this.examples[selectedRowIndex]
      testReportModule.setFailedExample(selectedExample)
    }
  }
}
</script>
